import { INameId } from '@modeso/types__aumico-lib-core-be';
import { IFliFormDialogResult } from './fli-form-dialog-result.interface';

export interface IFliFormDialogData {
    cashFlowTypeOptions?: INameId[];
    fliTypeOptions: INameId[];
    groupOptions: INameId[];
    existingFliNames: string[];
    fliToEdit?: IFliFormDialogResult;
    isCashFlowTypeForFliUsed: boolean;
}
